import React, { useState } from 'react'
import format from '@st-operations/uikit/lib/format'

import CountryDistribution from '_components/country-distribution/index.jsx'
import { Fragment } from 'react'

const GeographicalRegions = ({
  topCountriesData,
  distributionRegionData,
  hideZoomControls,
  disableClick,
}) => {
  const [position, setPosition] = useState({ coordinates: [0, 0], zoom: 1 })

  const renderGeographicalRegions = (region) => {
    return (
      <>
        <p className="de-events__distribution-legend-item">{region.region}</p>
        <p className="de-events__distribution-legend-item">{format('metric', region.users)}</p>
        <p className="de-events__distribution-legend-item">{format('metric', region.size)}</p>
        <p className="de-events__distribution-legend-item">{region.percentText}</p>
      </>
    )
  }

  return (
    <>
      <div className="de-events__distribution-vizualization-container">
        <CountryDistribution
          data={topCountriesData}
          hideZoomControls={hideZoomControls}
          position={position}
          onPositionChange={setPosition}
          disableClick={disableClick}
        />
      </div>
      <div className="de-events__distribution-legend">
        <span className="de-events__distribution-legend-header">Regions</span>
        <span className="de-events__distribution-legend-header">User Counts</span>
        <span className="de-events__distribution-legend-header">Event Counts</span>
        <span className="de-events__distribution-legend-header">% Total</span>
        <For each="eventType" of={distributionRegionData}>
          <Fragment key={`${eventType.region}`}>{renderGeographicalRegions(eventType)}</Fragment>
        </For>
      </div>
    </>
  )
}

export default GeographicalRegions
